import { MarkPaymentPaidInput } from "@/gql/graphql";
import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { CurrencyInput } from "@/lib/Components/Form/Inputs/CurrencyInput";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { markPaymentAsPaidMutation } from "@/app/Payments/GraphQL/paymentMutations";
import { PaymentListItem } from "@/app/Payments/GraphQL/paymentListQuery";

type PaymentMarkPaidDialogProps = {
  payment: PaymentListItem;
};

export function PaymentMarkPaidDialog({ payment }: PaymentMarkPaidDialogProps) {
  const { mutateAsync } = useGqlMutation(markPaymentAsPaidMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title="Manually pay">
      <GenericForm<MarkPaymentPaidInput>
        initialValues={{
          amount_paid: payment.amount_inc_tax,
          amount_refunded: 0,
          amount_fee: 0,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: payment.id,
            input: values,
          });
          await close();
        }}
      >
        <CurrencyInput
          name="amount_paid"
          label="Amount paid"
          currency={payment.currency}
        />
        <CurrencyInput
          name="amount_refunded"
          label="Amount refunded"
          currency={payment.currency}
        />
        <CurrencyInput
          name="amount_fee"
          label="Amount fee"
          currency={payment.currency}
        />
        <DialogSubmitButton text={"Mark as paid"} />
      </GenericForm>
    </BaseDialog>
  );
}
